import { useMutation, useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useQueryString } from "../../../Hooks/useQueryString";
import { Icon } from "../../Icon/Icon";
import { Button } from "../../SharedComponents/Button/Button";
import "./LoginAcceptedInvitation.css";

export const LoginAcceptedInvitation = () => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);
  const queryParams = useQueryString();
  const accountId = queryParams.get("aid");
  const email = queryParams.get("email");

  const { data, error, loading } = useQuery(getAccountName, {
    variables: { id: accountId },
  });
  const [acceptAccountInvitation] = useMutation(acceptInvitation);

  const history = useHistory();

  useEffect(() => {
    acceptAccountInvitation({ variables: { accountId, email } })
      .then((data) => {
        if (data?.data?.acceptAccountInvitation?.success) {
          setAccepted(true);
        }
      })
      .catch((err) => console.error(err));
  }, [data, accountId, email, acceptAccountInvitation]);

  return (
    <div className="LoginAcceptedInvitation">
      <div className="LoginAcceptedInvitation__title">
        <div className="LoginAcceptedInvitation__title-text">
          {accepted ? t("users.inviteAccepted") : t("users.inviteError")}
        </div>
      </div>
      <div className="LoginAcceptedInvitation__body">
        {!loading && !error && data && accepted && (
          <div className="LoginAcceptedInvitation__body-content">
            <div className="LoginAcceptedInvitation__body-text">
              {t("loginForm.loginAcceptedAt")} {data?.account?.name}
            </div>
            <div className="LoginAcceptedInvitation__icon">
              <Icon name="iconCheckmark" width={12} height={10} />
            </div>
          </div>
        )}
      </div>
      {!error && !loading && data && accepted && (
        <div className="LoginAcceptedInvitation__button">
          <Button
            click={() => history.push("/login")}
            buttonStyle="Button__primary"
          >
            {t("loginForm.login")}
          </Button>
        </div>
      )}
    </div>
  );
};

const getAccountName = gql`
  query account($id: String) {
    account(id: $id) {
      id
      name
    }
  }
`;

const acceptInvitation = gql`
  mutation acceptAccountInvitation($accountId: String, $email: String) {
    acceptAccountInvitation(accountId: $accountId, email: $email)
  }
`;
